module.exports = __webpack_public_path__ + "static/Icons-dc1202b3b45668890b707cfcfa6e36d2.gif";